import { excludeForwardProps } from '@gasbi/shared/common/utils/excludeForwardProps';

import { Button, styled } from '@mui/joy';

import { commonBaseButtonStyles } from '@components/BaseStyledComponents/common';

export const BaseButton = styled(Button, {
  shouldForwardProp: excludeForwardProps('isTransparent'),
})<{ isTransparent?: boolean }>(({ theme, isTransparent }) => ({
  ...commonBaseButtonStyles(theme),
  borderRadius: theme.spacing(1),
  justifyContent: 'flex-start',
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  backgroundColor: theme.palette.isDarkMode
    ? isTransparent
      ? 'transparent'
      : theme.palette.neutral[400]
    : theme.palette.neutral[50],
}));
